import { ContactForm } from "../../components/common/Form";

export const Feedback = () => {

  return (
    <>
      <h1>envie seu feedback</h1>
      <ContactForm />
    </>
  );
};